<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import store from './store'
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  font-family:"微软雅黑","Helvetica","宋体";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-menu{
  border-right:none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue